export const DOMAIN = 'jellyjump.voidall.com';
export const BASE_URL = `https://${DOMAIN}`;
